import React, { ReactElement } from 'react';
import moment from "moment";
import LinesEllipsis from 'react-lines-ellipsis';
import styles from './Banner.module.scss';
import { Carousel, ICarouselOptions } from '@kursk/components/ui/Carousel/Carousel';
import { BannerImage } from '@kursk/components/ui/BannerImage/BannerImage';
import { CustomButtonGroup } from '@kursk/components/ui/Carousel/Buttons/ButtonGroup';
import { IStream } from '@common/redux/types/stream';
import { Button } from "@kursk/components/ui/Button/Button";

interface IBannerWrapperProps {
  banners: IStream[];
}

export function Banner({ banners }: IBannerWrapperProps): ReactElement {

  const renderItem = (item: IStream) => {

    const isLive = moment().isBetween(moment(item.start), moment(item.end));
    const isFuture = moment().isBefore(moment(item.start));

    return (
      <div key={item._id} className={styles.wrapper}>
        <BannerImage
          desktopImage={item?.cover}
          tabletImage={item?.cover}
          mobileImage={item?.cover}
        />
        <div className={styles.content}>
          <div className={styles.category}>ТРАНСЛЯЦИЯ</div>
          <LinesEllipsis
            text={item.name}
            maxLine={4}
            ellipsis='...'
            trimRight
            basedOn='letters'
            className={styles.title}
          />
          <div className={styles.date}>{moment(item.start).format('D MMM, H:mm').toLowerCase()}</div>
          {isLive && (
            <div className={styles.bannerButton}>
              <Button className={styles.buttonGreen} href={`/streams/${item._id}/${item.sysName}`}>
                Смотреть
              </Button>
            </div>
          )}
          {isFuture && !isLive && (
            <div className={styles.bannerButton}>
              <Button className={styles.buttonSubmit} href={`/streams/${item._id}/${item.sysName}`}>
                Записаться
              </Button>
            </div>
          )}
        </div>
      </div>
    );
  }

  const options: ICarouselOptions = {
    infinite: true,
    autoPlay: banners.length > 1,
    autoPlaySpeed: 5000,
  };

  return (
    <Carousel
      Buttons={banners.length > 1 ? (
        <CustomButtonGroup className={styles.customButtonsGroup}/>
      ) : null}
      carouselOptions={options}
    >
      {banners.map((item) => renderItem(item))}
    </Carousel>
  );
}
